import type { FontEntry } from './font-registry';

const GOOGLE_FONTS_CSS2 = 'https://fonts.googleapis.com/css2';

/**
 * Одна ссылка CSS2 API Google Fonts на все Google-шрифты реестра.
 *
 * - Веса — по возрастанию через `;`: другой порядок API отвечает 400 на **весь** запрос, и тогда не
 *   грузится ни один шрифт. Тот же 400 даёт вес, которого у семейства нет, — поэтому веса записи
 *   проверяются замером (`.claude/docs/editor-fonts.md`), а не берутся «на всякий случай».
 * - У семейства с одним весом 400 ось не пишется: `family=Saira+Stencil+One`.
 * - `display=swap` — текст сразу рисуется запасным шрифтом и подменяется по загрузке
 *   (https://web.dev/articles/font-best-practices).
 *
 * CSS лёгкий: файлы шрифтов (`woff2`) браузер скачивает лениво — только семейства, веса и сабсеты
 * (`unicode-range`), которые реально нарисованы. Канва сама загрузку не просит, поэтому перед
 * отрисовкой её ждёт `ensureFonts`.
 */
export function buildGoogleFontsUrl(registry: readonly FontEntry[]): string {
  const families = registry
    .filter((entry) => entry.source === 'google')
    .map((entry) => {
      const name = entry.family.trim().replace(/ /g, '+');
      const weights = Array.from(new Set(entry.weights)).sort((a, b) => a - b);
      if (weights.length === 1 && weights[0] === 400) return `family=${name}`;
      return `family=${name}:wght@${weights.join(';')}`;
    });
  return `${GOOGLE_FONTS_CSS2}?${[...families, 'display=swap'].join('&')}`;
}
